import React from "react";

import styled from "styled-components";
import { capitalize } from "underscore.string";

const StyledAvatarImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
`;

const StyledWrapper = styled.div`
  display: flex;
`;

const ByLineWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

const Author = ({ firstName, lastName, image }) => (
  <StyledWrapper>
    <StyledAvatarImage src={image.src} />
    <ByLineWrapper>
      <div>
        {"Writen by "}
        <strong>{`${capitalize(firstName)} ${capitalize(lastName)}`}</strong>
      </div>
    </ByLineWrapper>
  </StyledWrapper>
);

export default Author;
